/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Report_Group_ByInputs */

const vi_report_group_by = /** @type {(inputs: Report_Group_ByInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nhóm theo`)
};

/**

* @param {Report_Group_ByInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const report_group_by = /** @type {((inputs?: Report_Group_ByInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Report_Group_ByInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_report_group_by(inputs)
});